
import { Category, Order, Product, Restaurant, Coupon } from '../types';

export const MOCK_RESTAURANT: Restaurant = {
  id: 'rest_01',
  slug: 'orderflow-demo',
  username: 'OrderFlow Business',
  niche: 'SERVICES',
  plan: 'PRO',
  followersCount: 12345,
  postsCount: 123,
  engagementRate: 5.4,
  setupCompleted: true,
  logoUrl: 'https://images.unsplash.com/photo-1598214886806-c87b84b7078b?q=80&w=200',
  bannerUrl: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?q=80&w=1200',
  styles: {
    primaryColor: '#f43f5e',
    secondaryColor: '#f43f5e',
    backgroundColor: '#ffffff',
    surfaceColor: '#ffffff',
    textColor: '#000000',
    borderRadius: 'large',
    fontHeading: 'sans',
    fontBody: 'sans',
    themeMode: 'light',
    designTheme: 'neo-expression',
    cardStyle: 'floating',
    buttonStyle: 'pill',
    shadowIntensity: 'none',
    bannerOpacity: 1
  },
  currency: 'BRL',
  isOpen: true,
  minOrderValue: 0,
  address: 'Digital Office, World',
  phone: '(11) 99999-9999',
  delivery: {
    fee: 0,
    minOrderForFreeDelivery: 0,
    estimatedMin: 1,
    estimatedMax: 5
  },
  payment: {
    acceptPix: true,
    acceptCard: true,
    acceptCash: false,
    pixKey: 'orderflow@pix.com'
  },
  landing: {
    heroTitle: "Sua Escala Começa Aqui",
    heroSubtitle: "Cardápio Digital de alta performance para seu restaurante."
  },
  social: {
    instagram: 'https://instagram.com',
    whatsapp: 'https://wa.me/5511999999999'
  },
  aiConfig: {
    agentName: "Chef IA",
    tone: "Professional",
    instructions: "Foque em vender mais e encantar clientes."
  }
};

export const MOCK_COUPONS: Coupon[] = [];
export const MOCK_CATEGORIES: Category[] = [];
export const MOCK_PRODUCTS: Product[] = [];
export const MOCK_ORDERS: Order[] = [];
